export default __webpack_public_path__ + "62e79cc76363009d18ecc57cb5edd276.png";